import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  clickLink(event) {
    this.linkTarget.click();
  }
}
